<template>
    <div class="acomodar">
        <PuestosRegistrar />

        <!-- <iframe src="http://futbollatam.com/en-vivo/espn-1/?ver"  width="100" height="200" frameborder="0"></iframe> -->
    </div>
</template>

<script>
import PuestosRegistrar from '@/components/ModSeleccion/Puesto/RegistrarPuesto.vue';
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global
export default {
    name: "SolimanologRegistrarPuesto",
    data() {
        return {};
    },
    mounted() {
    },
    methods: {},
    components: { PuestosRegistrar }
};
</script>
